// import React, { useEffect, useRef } from "react";

// const services = [
//     {
//         title: "Customer Software Solutions",
//         description:
//             "Custom software created specifically for your business or service will increase productivity without forcing organizational change.",
//         icon: "💻",
//         borderColor: "#FFCCBC",
//         accentColor: "#f96639ff",
//         accentType: "topLeftL",
//     },
//     {
//         title: "Web, Cloud, SaaS",
//         description:
//             "Custom software created specifically for your business or service will increase productivity without forcing organizational change.",
//         icon: "☁️",
//         borderColor: "#BBDEFB",
//         accentColor: "#46a7f6ff",
//         accentType: "topCenterLongPill",
//     },
//     {
//         title: "Amazon FBA (MWS) and eCommerce",
//         description:
//             "Custom software created specifically for your business or service will increase productivity without forcing organizational change.",
//         icon: "🛒",
//         borderColor: "#B2EBF2",
//         accentColor: "#38b2c2ff",
//         accentType: "topRightL",
//     },
//     {
//         title: "Mobile Applications",
//         description:
//             "Custom software created specifically for your business or service will increase productivity without forcing organizational change.",
//         icon: "📱",
//         borderColor: "#E1BEE7",
//         accentColor: "#af3bcfff",
//         accentType: "bottomLeftL",
//     },
//     {
//         title: "Database Expertise",
//         description:
//             "Custom software created specifically for your business or service will increase productivity without forcing organizational change.",
//         icon: "🗄️",
//         borderColor: "#C8E6C9",
//         accentColor: "#42a146ff",
//         accentType: "bottomCenterLongPill",
//     },
//     {
//         title: "Technical Documentation",
//         description:
//             "Custom software created specifically for your business or service will increase productivity without forcing organizational change.",
//         icon: "📄",
//         borderColor: "#FFE0B2",
//         accentColor: "#FB8C00",
//         accentType: "bottomRightL",
//     },
// ];

// const OurServices = () => {

//     const gridRef = useRef(null);

//     useEffect(() => {
//         const node = gridRef.current;
//         if (!node) return;

//         const io = new IntersectionObserver(
//             ([entry]) => {
//                 if (entry.isIntersecting) {
//                     node.classList.add("animate-cards");
//                     io.disconnect();
//                 }
//             },
//             { threshold: 0.2 }
//         );

//         io.observe(node);
//         return () => io.disconnect();
//     }, []);

//     return (
//         <section className="py-5 position-relative" style={{ overflow: "hidden" }}>
//             <div
//                 className="px-3 px-md-4 mx-auto position-relative"
//                 style={{ maxWidth: "73%", zIndex: 1 }}
//             >
//                 {/* Heading */}
//                 <div style={{ marginTop: "80px" }}>
//                     <h2
//                         style={{
//                             fontSize: "44px",
//                             fontFamily: "'Inter', sans-serif",
//                             fontWeight: 650,
//                             color: "#1C1C1C",
//                             lineHeight: 1.2,
//                         }}
//                     >
//                         What we do?
//                     </h2>
//                     <p
//                         className="mt-2"
//                         style={{
//                             fontSize: "20px",
//                             color: "#6B6B6B",
//                             fontWeight: 400,
//                             fontFamily: "'Inter', sans-serif",
//                         }}
//                     >
//                         Building a connected ecosystem of business suites-powered by WhatsApp, tailored for every function.
//                     </p>
//                 </div>

//                 {/* Cards grid */}
//                 <div
//                     ref={gridRef}
//                     className="row g-3 g-md-4"
//                     style={{ marginTop: "20px" }}
//                 >
//                     {services.map((s, idx) => {
//                         // 1,4 -> left | 2,5 -> top | 3,6 -> right
//                         const mod = idx % 3; // 0,1,2,0,1,2...
//                         const animClass =
//                             mod === 0 ? "anim-left" : mod === 1 ? "anim-top" : "anim-right";

//                         return (
//                             <div className={`col-12 col-sm-6 col-md-4 card-wrap ${animClass}`} key={idx}>
//                                 <article
//                                     className="h-100 position-relative bg-white"
//                                     style={{
//                                         border: `2px solid ${s.borderColor}`,
//                                         borderRadius: 16,
//                                         boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
//                                         transition: "transform .25s ease",
//                                         minHeight: "270px",
//                                         maxWidth: "98%",
//                                     }}
//                                     onMouseEnter={(e) =>
//                                         (e.currentTarget.style.transform = "translateY(-4px)")
//                                     }
//                                     onMouseLeave={(e) =>
//                                         (e.currentTarget.style.transform = "translateY(0)")
//                                     }
//                                 >
//                                     {/* Accent decorations */}
//                                     <span
//                                         className={`accent ${s.accentType}`}
//                                         style={{ ["--accent"]: s.accentColor }}
//                                     />

//                                     <div className="d-flex flex-column align-items-center text-center h-100 p-3 p-sm-4">
//                                         <div
//                                             style={{
//                                                 fontSize: 34,
//                                                 lineHeight: 1,
//                                                 marginBottom: 8,
//                                             }}
//                                             aria-hidden
//                                         >
//                                             {s.icon}
//                                         </div>

//                                         <h3
//                                             className="m-0"
//                                             style={{
//                                                 color: s.accentColor,
//                                                 fontFamily: "'Inter', sans-serif",
//                                                 fontWeight: 600,
//                                                 fontSize: "20px",
//                                                 lineHeight: 1.3,
//                                             }}
//                                         >
//                                             {s.title}
//                                         </h3>

//                                         <p
//                                             className="mt-2 mb-0"
//                                             style={{
//                                                 fontFamily: "'Inter', sans-serif",
//                                                 fontSize: "16px",
//                                                 lineHeight: 1.3,
//                                                 color: "#6B6B6B",
//                                             }}
//                                         >
//                                             {s.description}
//                                         </p>
//                                     </div>
//                                 </article>
//                             </div>
//                         );
//                     })}
//                 </div>
//             </div>

//             {/* tiny CSS for colored accents + animations */}
//             <style>{`
//         .accent {
//           position: absolute;
//           z-index: 2;
//           pointer-events: none;
//         }
//         /* corner L shapes */
//         .topLeftL {
//           top: 0; left: 0;
//           width: 54px; height: 54px;
//           border-top: 5px solid var(--accent);
//           border-left: 5px solid var(--accent);
//           border-top-left-radius: 14px;
//         }
//         .topRightL {
//           top: 0; right: 0;
//           width: 56px; height: 56px;
//           border-top: 5px solid var(--accent);
//           border-right: 5px solid var(--accent);
//           border-top-right-radius: 14px;
//         }
//         .bottomLeftL {
//           bottom: 0; left: 0;
//           width: 56px; height: 56px;
//           border-bottom: 5px solid var(--accent);
//           border-left: 5px solid var(--accent);
//           border-bottom-left-radius: 14px;
//         }
//         .bottomRightL {
//           bottom: 0; right: 0;
//           width: 56px; height: 56px;
//           border-bottom: 5px solid var(--accent);
//           border-right: 5px solid var(--accent);
//           border-bottom-right-radius: 14px;
//         }
//         /* center short pills */
//         .topCenterLongPill {
//           top: 0; left: calc(50% - 30px);
//           width: 60px; height: 5px;
//           background-color: var(--accent);
//           border-radius: 14px;
//         }
//         .bottomCenterLongPill {
//           bottom: 0; left: calc(50% - 30px);
//           width: 60px; height: 5px;
//           background-color: var(--accent);
//           border-radius: 14px;
//         }

//         /* ===== Animations (design unchanged) ===== */
//         .card-wrap { opacity: 0; }
//         .animate-cards .anim-left  { animation: fadeLeft .75s ease-out forwards; }
//         .animate-cards .anim-top   { animation: fadeTop  .75s ease-out forwards; }
//         .animate-cards .anim-right { animation: fadeRight .75s ease-out forwards; }

//         @keyframes fadeLeft {
//           from { opacity: 0; transform: translateX(-36px); }
//           to   { opacity: 1; transform: translateX(0); }
//         }
//         @keyframes fadeTop {
//           from { opacity: 0; transform: translateY(-36px); }
//           to   { opacity: 1; transform: translateY(0); }
//         }
//         @keyframes fadeRight {
//           from { opacity: 0; transform: translateX(36px); }
//           to   { opacity: 1; transform: translateX(0); }
//         }

//         /* optional: slight stagger so तीनों directions pleasantly दिखाई दें */
//         .animate-cards .card-wrap:nth-child(1) { animation-delay: .05s; }
//         .animate-cards .card-wrap:nth-child(2) { animation-delay: .1s; }
//         .animate-cards .card-wrap:nth-child(3) { animation-delay: .15s; }
//         .animate-cards .card-wrap:nth-child(4) { animation-delay: .2s; }
//         .animate-cards .card-wrap:nth-child(5) { animation-delay: .25s; }
//         .animate-cards .card-wrap:nth-child(6) { animation-delay: .3s; }

//         @media (max-width: 576px) {
//           .topLeftL, .topRightL, .bottomLeftL, .bottomRightL {
//             width: 48px; height: 48px;
//             border-width: 4px;
//           }
//           .topCenterLongPill, .bottomCenterLongPill {
//             width: 50px; height: 4px; left: calc(50% - 25px);
//           }
//         }
//       `}</style>
//         </section>
//     );
// };

// export default OurServices;

/*************************************************************************************************************/

import React, { useEffect, useRef } from "react";

const CARDS = [
  {
    title: "Mobile App Development",
    desc: "Build secure native and cross-platform apps with seamless experiences.",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
        <rect x="7" y="2" width="10" height="20" rx="2" stroke="currentColor" fill="none" strokeWidth="2" />
        <circle cx="12" cy="18" r="1.5" fill="currentColor" />
      </svg>
    ),
  },
  {
    title: "Website & Web App Development",
    desc: "Create responsive, scalable web solutions for modern businesses.",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="9" stroke="currentColor" fill="none" strokeWidth="2" />
        <path d="M3 12h18M12 3c3 4 3 14 0 18M12 3c-3 4-3 14 0 18" stroke="currentColor" strokeWidth="2" fill="none"/>
      </svg>
    ),
  },
  {
    title: "AI & Chatbot Development",
    desc: "Develop intelligent AI chatbots to automate support and boost engagement.",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
        <rect x="4" y="7" width="16" height="10" rx="3" stroke="currentColor" fill="none" strokeWidth="2" />
        <circle cx="9" cy="12" r="1" fill="currentColor" />
        <circle cx="15" cy="12" r="1" fill="currentColor" />
        <path d="M12 7V4" stroke="currentColor" strokeWidth="2" />
      </svg>
    ),
  },
  {
    title: "Analytics",
    desc: "Leverage data analytics to gain actionable insights for business growth.",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 19h16M7 17V9M12 17V5M17 17v-7" stroke="currentColor" strokeWidth="2" fill="none" />
      </svg>
    ),
  },
  {
    title: "Automation",
    desc: "Streamline processes with smart automation to enhance efficiency and output.",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" fill="none" />
        <path d="M19.4 15a7.96 7.96 0 0 0 .4-3m-1.6 5l-2-1m-8.4 1-2 1m-1.6-5a7.96 7.96 0 0 1 0-3m1.6-5 2 1m8.4-1 2-1" stroke="currentColor" strokeWidth="2" fill="none"/>
      </svg>
    ),
  },
  {
    title: "Cloud Integration",
    desc: "Enable seamless cloud migration, integration and optimized resource management.",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M7 18h9a4 4 0 1 0-.9-7.9A5 5 0 0 0 6 11a3 3 0 0 0 1 7z" stroke="currentColor" strokeWidth="2" fill="none"/>
      </svg>
    ),
  },
];

const OurServices = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("fade-on-scroll--in");
          io.unobserve(el);
        }
      },
      { threshold: 0.2, rootMargin: "0px 0px -10% 0px" } // safe units
    );

    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="py-4 position-relative fade-on-scroll"
      style={{ overflow: "hidden" }}
    >
      <div
        className="px-5 x-xxl-5 px-6 mx-auto position-relative"
        style={{ maxWidth: "74%", zIndex: 1, marginTop: 60 }}
      >
        {/* Heading */}
        <div>
          <h2
            style={{
              fontSize: "44px",
              fontFamily: "Inter",
              fontWeight: 650,
              color: "#242121ff",
              lineHeight: 1.2,
            }}
          >
            What we do?
          </h2>
          <p
            className="mt-2"
            style={{
              fontSize: "20px",
              color: "#6B6B6B",
              fontWeight: 400,
              fontFamily: "Inter",
            }}
          >
            Building a connected ecosystem of business suites-powered by WhatsApp, tailored for every function.
          </p>
        </div>

        {/* Cards */}
        <div className="row g-4 mt-3">
          {CARDS.map((c, i) => (
            <div className="col-12 col-md-6 col-lg-4" key={i}>
              <article className="svc-card">
                <div className="svc-icon" aria-hidden>
                  {c.icon}
                </div>
                <h3 className="svc-title">{c.title}</h3>
                <p className="svc-desc">{c.desc}</p>
              </article>
            </div>
          ))}
        </div>
      </div>

      {/* styles */}
      <style>{`
        :root{
          --blue:#0A56A2;
          --icon-bg: rgba(10,86,162,.10);
          --card-border:#E6EEF8;
          --text-dark:#1f2937;
          --text-muted:#6B6B6B;
        }

        /* === fade in from bottom on first view === */
        .fade-on-scroll{
          opacity: 0;
          transform: translateY(40px);
          will-change: transform, opacity;
        }
        .fade-on-scroll.fade-on-scroll--in{
          animation: fadeUp .8s ease-out forwards;
        }
        @keyframes fadeUp{
          0%   { opacity:0; transform: translateY(40px); }
          100% { opacity:1; transform: translateY(0); }
        }
        @media (prefers-reduced-motion: reduce){
          .fade-on-scroll{ opacity:1 !important; transform:none !important; animation:none !important; }
        }

        .svc-card{
          --radius:16px;
          --pad:22px;
          position:relative;
          display:flex;
          flex-direction:column;
          gap:10px;
          min-height:250px;
          height:100%;
          border-radius:var(--radius);
          background:#fff;
          border:1px solid var(--card-border);
          box-sizing:border-box;
          box-shadow:0 1px 2px rgba(16,24,40,.04);
          padding: calc(var(--pad) + 6px) var(--pad) var(--pad);
          transition: transform .22s ease, box-shadow .22s ease, border-color .22s ease, border-top-width .22s ease;
        }

        .svc-icon{
          width:52px; height:52px;
          border-radius:12px;
          display:grid; place-items:center;
          background: var(--icon-bg);
          color: var(--blue);
          border: 1px solid rgba(10,86,162,.10);
          transition: background .22s ease, color .22s ease, border-color .22s ease;
        }

        .svc-title{
          margin: 2px 0 0;
          font: 600 22px/1.35 Inter, system-ui;
          color: var(--text-dark);
        }
        .svc-desc{
          margin: 4px 0 0;
          font: 16px/1.35 Inter, system-ui;
          color: var(--text-muted);
        }

        /* Hover — lift + top highlight (3px) + icon invert */
        .svc-card:hover{
          transform: translateY(-10px);
          box-shadow:
            0 10px 24px rgba(10,86,162,.10),
            0 4px 10px rgba(16,24,40,.06);
          border-top-color: var(--blue);
          border-top-width: 3px;       /* your 3px highlight */
        }
        .svc-card:hover .svc-icon{
          background: var(--blue);
          color: #fff;
          border-color: transparent;
        }

        @media (max-width: 575.98px){
          .svc-card{ min-height: 200px; }
          .svc-title{ font-size:20px; }
        }
      `}</style>
    </section>
  );
};

export default OurServices;

